import { render, staticRenderFns } from "./Ibero.vue?vue&type=template&id=5787f338&"
import script from "./Ibero.vue?vue&type=script&lang=js&"
export * from "./Ibero.vue?vue&type=script&lang=js&"
import style0 from "./Ibero.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports